(() => {
  const init = (media) => {
    if (media.hasAttribute('data-ready')) return;

    const player = media.querySelector('.lp-video-reviews__player');
    const button = media.querySelector('.lp-video-reviews__play');
    if (!player || !button) return;

    const section = media.closest('.lp-video-reviews') || document;

    button.addEventListener('click', () => {
      section.querySelectorAll('.lp-video-reviews__player').forEach((other) => {
        if (other !== player) other.pause();
      });

      media.setAttribute('data-playing', '');
      const played = player.play();
      if (played) played.catch(() => media.removeAttribute('data-playing'));
    });

    media.setAttribute('data-ready', '');
  };

  const initAll = (scope) => {
    if (scope instanceof Element && scope.matches('[data-lp-video]')) init(scope);
    scope.querySelectorAll('[data-lp-video]').forEach(init);
  };

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
